import styles from './Button.module.css';

const Button = ({buttonText, buttonUrl}: {buttonText: string, buttonUrl: string}) => {
    return <a className={styles.button} href={buttonUrl} target="_blank" rel="noreferrer">{buttonText}</a>
}

export default Button
